import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { TopBar } from "@/components/TopBar";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { WhyChoose } from "@/components/WhyChoose";
import { HowItWorks } from "@/components/HowItWorks";
import { ProductGrid } from "@/components/ProductGrid";
import { ZonaSul } from "@/components/ZonaSul";
import { Cemiterios } from "@/components/Cemiterios";
import { CTABanner } from "@/components/CTABanner";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { MobileStickyBar } from "@/components/MobileStickyBar";
import { CartDrawer } from "@/components/CartDrawer";

const SECTION_BY_PATH = {
  "/catalogo": "catalogo",
  "/zona-sul": "zona-sul",
  "/como-funciona": "como-funciona",
  "/cobertura": "cobertura",
  "/duvidas": "faq",
  "/faq": "faq",
  "/contato": "contato",
};

const Landing = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const section = SECTION_BY_PATH[pathname];
    if (!section) {
      window.scrollTo({ top: 0, behavior: "auto" });
      return;
    }
    const t = setTimeout(() => {
      const el = document.getElementById(section);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 250);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#F9F8F6] text-[#1C1C1C] pb-20 md:pb-0">
      <TopBar />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <ProductGrid />
        <ZonaSul />
        <WhyChoose />
        <Cemiterios />
        <CTABanner />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <MobileStickyBar />
      <CartDrawer />
    </div>
  );
};

function App() {
  return (
    <CartProvider>
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/catalogo" element={<Landing />} />
          <Route path="/zona-sul" element={<Landing />} />
          <Route path="/como-funciona" element={<Landing />} />
          <Route path="/cobertura" element={<Landing />} />
          <Route path="/duvidas" element={<Landing />} />
          <Route path="/faq" element={<Landing />} />
          <Route path="/contato" element={<Landing />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
